import { APP_INITIALIZER, NgModule } from '@angular/core';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { BrowserModule } from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import { MatPaginatorModule } from '@angular/material/paginator';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';

import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { KeycloakAngularModule, KeycloakService } from 'keycloak-angular';

import { LayoutModule } from '@angular/cdk/layout';
import { ScrollingModule } from '@angular/cdk/scrolling';

import { WorkGroupsComponent } from './chat-module/work-groups/work-groups.component';
import { NotFoundComponent } from './not-found/not-found.component';

import { environment } from './../environments/environment';
import { KeycloakTokenInterceptorInterceptor } from './shared/interceptors/keycloak-token-interceptor.interceptor';
import { UnloadService } from './unload.service';


export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

/*
  onLoad: 'check-sso' --> en caso de que necesiten tener paginas dentro del proyecto de manera publica, por ejemplo algun tipo de registro de usuarios.
  onLoad: 'login-required' --> en caso de que siempre se necesite estar loggeado para ver cualquier pagina dentro del proyecto
  config:
  url: url del servidor keycloak donde se configuraran los reinos(Realms) y clientes
  realm: nombre del reino configurado en el servidor keycloak
  clientId: nombre u id del cliente configurado en el servidor de keycloak
*/

function initializeKeycloak(keycloak: KeycloakService) {
  return () =>
    keycloak.init({
      config: {
        // url: 'https://bc-pre.conceptomovil.com/kc-sso/',
        // realm: 'broadcaster-bot',
        // clientId: 'bot_user'
        url: environment.keycloakUrl,
        realm: environment.keycloakRealmName,
        clientId: environment.keycloakClientId
      },
      enableBearerInterceptor: false,
      loadUserProfileAtStartUp: false,
      initOptions: {
        onLoad: 'check-sso',
        checkLoginIframe: false, // false because if true not function on apple devices
        //checkLoginIframeInterval: 10 // commented because not function on apple devices
      },
      bearerExcludedUrls: [],
    });
}

@NgModule({
  declarations: [
    AppComponent,
    WorkGroupsComponent,
    NotFoundComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    TranslateModule.forRoot({
      defaultLanguage: "es",
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
    LayoutModule,
    MatToolbarModule,
    MatButtonModule,
    MatSidenavModule,
    MatIconModule,
    MatListModule,
    MatFormFieldModule,
    ScrollingModule,
    ReactiveFormsModule,
    FormsModule,
    MatDialogModule,
    MatInputModule,
    KeycloakAngularModule,
    MatPaginatorModule,
  ],

  providers: [TranslateService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeKeycloak,
      multi: true,
      deps: [KeycloakService]
    },
    UnloadService,
   //{ provide: HTTP_INTERCEPTORS, useClass: KeycloakTokenInterceptorInterceptor, multi: true }
  ],

  bootstrap: [AppComponent]
})
export class AppModule { }
